import Vue from 'vue'
import Router from 'vue-router'

import About from '@/components/About'
import Partners from '@/components/Partners'
import Register from '@/components/Register'
import RegisterConfirmation from '@/components/RegisterConfirmation'
import CategoriesList from '@/components/CategoriesList'
import Category from '@/components/Category'
import Form from '@/components/Form'
import Legal from '@/components/Legal'
import Credits from '@/components/Credits'
import Profile from '@/components/Profile'
import Contact from '@/components/Contact'
import Events from '@/components/Events'
import Login from '@/components/Login'
import Formation from '@/components/Formation'
import Recover from '@/components/Recover'
import PasswordRecovery from '@/components/PasswordRecovery'

Vue.use(Router);

console.log("TEST : INDEX.JS");

const router = new Router({
  routes: [
    {path: '/formation', name: 'formation', component: Formation, children: [
        {
          path: ':category_code',
          name: 'category',
          component: Category,
          props: true
        },
      ]
    },
    {path: '/register', name: 'register', component: Register},
    {path: '/register/:token', name: 'registerConfirmation', component: RegisterConfirmation},
    {path: '/register2', name: 'register2', component: Register},
    {path: '/profile', name: 'profile', component: Profile},
    {path: '/about', name: 'about', component: About},
    {path: '/partners', name: 'partners', component: Partners},
    {path: '/form', name: 'form', component: Form},
    {path: '/legal', name: 'legal', component: Legal},
    {path: '/login', name: 'login', component: Login},
    {path: '/credits', name: 'credits', component: Credits},
    {path: '/contact', name: 'contact', component: Contact},
    {path: '/events', name: 'events', component: Events},
    {path: '/recover', name: 'recover', component: Recover},
    {path: '/recover/:userId/:token', name: 'passwordRecovery', component: PasswordRecovery},
    {path: '/', name: 'index', component: CategoriesList, children: [
        {
          path: ':category_code',
          name: 'category',
          component: Category,
          props: true
        },
      ]
    }
  ],
  mode: 'history'
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js